import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

interface IProps {
    label: string
    value: string
}

export function HorizontalShowInfo(props: IProps) {
    const { label, value } = props
    return (
        <Form.Group as={Row} className='mb-2' controlId={`formHorizontal${label.replace(/\s/g, '')}`}>
            <Form.Label column xs={4}>
                {label}
            </Form.Label>
            <Col xs={8}>
                <Form.Control type='text' value={value} readOnly />
            </Col>
        </Form.Group>
    )
}
